import { Button, TextField, Typography } from "@mui/material";
import styles from "./styles.module.scss";
import { Controller, ControllerRenderProps, useForm } from "react-hook-form";
import { textFieldStyles, submitButtonStyles, backButtonStyles } from "./theme";
import { useRecoveryPassword } from "@src/entities/login";
import { useEffect, useState } from "react";

interface ResetPasswordStep2Props {
  login: string;
  code: string;
}
interface Props {
  login: string;
  setStep: (step: number) => void;
  setData: (data: any) => void;
}

export const ResetPasswordStep2 = ({ login, setStep, setData }: Props) => {
  const [attempts, setAttempt] = useState<number>(0);

  const { mutate: recoveryPassword, error } = useRecoveryPassword();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useForm<ResetPasswordStep2Props>({
    defaultValues: {
      login: login,
      code: "",
    },
    mode: "onTouched",
  });

  useEffect(() => {
    if (error) {
      setValue("code", "");
    }
  }, [error]);

  const onSubmit = (data: ResetPasswordStep2Props) => {
    recoveryPassword(
      { login: data.login, code: data.code },
      {
        onSuccess: () => {
          setData((prev: any) => ({ ...prev, code: data.code }));
          setStep(3);
        },
        onError: () => {
          if (attempts === 2) {
            setStep(1);
            return;
          }
          setAttempt((prev) => prev + 1);
        },
      }
    );
  };

  return (
    <>
      <div className={styles.formTitleContainer}>
        <Typography className={styles.formTitle}>
          Восстановление пароль
        </Typography>
        <Typography className={styles.formTitle2}>Шаг 2</Typography>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <Controller
          name="login"
          control={control}
          render={({
            field,
          }: {
            field: ControllerRenderProps<ResetPasswordStep2Props, "login">;
          }) => (
            <TextField
              {...field}
              label="Почта"
              variant="outlined"
              type="email"
              fullWidth
              disabled
              error={!!errors.login}
              helperText={errors.login?.message}
              className={styles.input}
              InputProps={{
                style: {
                  borderRadius: 24,
                  color: "#fff",
                },
              }}
              InputLabelProps={{
                style: { color: "#ffffff83" },
              }}
              sx={textFieldStyles}
            />
          )}
        />
        <Controller
          name="code"
          control={control}
          rules={{
            required: "Поле обязательно для заполнения",
            minLength: {
              value: 6,
              message: "Код должен содержать 6 цифр",
            },
            maxLength: {
              value: 6,
              message: "Код должен содержать 6 цифр",
            },
            pattern: {
              value: /^\d+$/,
              message: "Код должен содержать только цифры",
            },
          }}
          render={({
            field,
          }: {
            field: ControllerRenderProps<ResetPasswordStep2Props, "code">;
          }) => (
            <TextField
              {...field}
              label="Код подтверждения"
              variant="outlined"
              type="text"
              fullWidth
              error={!!errors.code}
              helperText={errors.code?.message}
              className={styles.input}
              InputProps={{
                style: {
                  borderRadius: 24,
                  color: "#fff",
                },
              }}
              InputLabelProps={{
                style: { color: "#ffffff83" },
              }}
              sx={textFieldStyles}
            />
          )}
        />
        <Button
          disabled={!isValid}
          type="submit"
          variant="contained"
          className={styles.button}
          sx={submitButtonStyles}
        >
          Отправить код подтверждения
        </Button>
      </form>
      <Button variant="text" onClick={() => setStep(1)} sx={backButtonStyles}>
        Вернуться
      </Button>
    </>
  );
};
